module.exports = __webpack_public_path__ + "assets/img/客户墙.1779ca19.png";